import { FC } from 'react';

interface TextareaInputProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
  error?: boolean;
  rows?: number;
  resize?: 'none' | 'vertical' | 'horizontal' | 'both';
}

export const TextareaInput: FC<TextareaInputProps> = ({
  className = '',
  placeholder = '',
  error = false,
  rows = 3,
  resize = 'vertical',
  ...props
}) => {
  const getResizeClass = () => {
    switch (resize) {
      case 'none':
        return 'resize-none';
      case 'vertical':
        return 'resize-y';
      case 'horizontal':
        return 'resize-x';
      case 'both':
        return 'resize';
      default:
        return 'resize-y';
    }
  };

  return (
    <textarea
      rows={rows}
      className={`block w-full border rounded-md pl-4 p-2 placeholder:text-gray-400 dark:placeholder:text-gray-500 placeholder:text-sm
           text-sm text-gray-900 dark:text-white bg-white dark:bg-gray-800 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200 ${
             error
               ? 'border-red-500 focus:border-red-500 focus:ring-red-500'
               : 'border-gray-300 dark:border-gray-600'
           } ${getResizeClass()} ${className}`}
      placeholder={placeholder}
      {...props}
    />
  );
};
